import { history } from 'legacy/lut/helpers/route'
import { useEffect, useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

import { selectSitePages } from 'core-components/sitebuilder/store/selectors/selectSitePages'
import { LocationCompatible } from 'shared/lib/location'

const basePush = history.push
let firstRender = true
let historyListenCallbacks: any = []

export const useHistoryCompatible = () => {
  const navigation = useNavigate()
  const location = useLocation()
  const sitePages = useSelector(selectSitePages)

  useEffect(() => {
    history.push = (location: string, state: any) => {
      navigation(location, { state })
      basePush(location, state)
    }

    history.listen = (callback: any) => {
      historyListenCallbacks.push(callback)
      return () => {
        historyListenCallbacks = historyListenCallbacks.filter((el: any) => {
          return el !== callback
        })
      }
    }

    try {
      Object.defineProperty(history.location, 'pathname', {
        get: function () {
          return location.pathname
        },
      })
    } catch (err) {}
  }, [])

  useLayoutEffect(() => {
    LocationCompatible.setLocation(location)
  }, [location, sitePages])

  useEffect(() => {
    if (firstRender) {
      firstRender = false
    } else {
      historyListenCallbacks.map((callback: any) => callback())
    }
  }, [location])
}
